import IParamScriptsRule from '../database/IParamScriptsRule';
import NameConfigurator from './NameConfigurator';
import SizeConfigurator from './SizeConfigurator';
import MaterialConfigurator from './MaterialConfigurator';

// This script will interpret a cabinet descriptor file and render the ui for it
class ParamScriptsProcessor {

    public readonly nameConf: NameConfigurator | null = null;
    public readonly sizeConf: { [key: string] :SizeConfigurator; } = {};
    public readonly matConf: { [key: string]: MaterialConfigurator; } = {};
    public readonly usedTabs: Set<string> = new Set();

    constructor(paramsList: IParamScriptsRule[], setParameters: () => void) {
        for (let rule of paramsList) {
            this.usedTabs.add(rule.tab);
            try {
                if(rule.parameterType != null) {
                    if (rule.panel != null) {
                        // Panels are not handled in this version, skip
                        continue;
                    }
                    if(rule.parameterType === "Text") {
                        this.nameConf = new NameConfigurator(rule);
                    } else if(rule.parameterType === "Size" ||
                        rule.parameterType === "Size2D" ||
                        rule.parameterType === "Size3D") {
                        if(this.sizeConf[rule.parameterName] == null) 
                            this.sizeConf[rule.parameterName] = new SizeConfigurator(rule, setParameters);
                    } else if(rule.parameterType === "Decor") { // it can have multiple entries
                        // can be: BaseMaterial, FrontMaterial, BackMaterial, ShelfMaterial, DrawerMaterial
                        if(this.matConf[rule.parameterName] == null)
                            this.matConf[rule.parameterName] = new MaterialConfigurator(rule, setParameters);
                    } else if(rule.parameterType === "Count" || rule.parameterType === "Enum") {
                        // Not handled in this version
                    } else {
                        alert("Unhandled param script type: " + rule.parameterType);
                    }
                }
            } catch(e) {
                console.log("Exception in param script handling: " + rule.tab);
                throw e;
            }
        }
    }

    public cleanup(): void {
        this.nameConf?.cleanup();

        for (let key in this.sizeConf) {
            this.sizeConf[key]?.cleanup();
        }
        
        for (let key in this.matConf) {
            this.matConf[key]?.cleanup();
        }
    }
}

export default ParamScriptsProcessor;
